// eslint-disable-next-line import/prefer-default-export
export const options = {
	replace: (domNode) => {
		if (domNode.attribs && domNode.attribs.class === 'remove') {
			// eslint-disable-next-line react/react-in-jsx-scope
			return <></>;
		}
	},
};
